export interface AcademyWizardStep {
  path: string;
  badgeKey: string;
  progress: number;
}

// progress values traced from the design (250/600 and 590/600), not computed
// from the counter: the near-full step-2 bar is intentional "almost done".
export const academyWizardSteps: AcademyWizardStep[] = [
  {
    path: "/academy/wizard/general",
    badgeKey: "Facility basics",
    progress: 41.67,
  },
  {
    path: "/academy/wizard/coach-profile",
    badgeKey: "Coach Identity",
    progress: 98.33,
  },
];

// Derived, so adding or removing a step can never leave the counter stale.
export const ACADEMY_WIZARD_STEP_TOTAL = academyWizardSteps.length;
